import { MoreHorizontal, MessageSquare } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  ICON_SIZE,
} from '../design-system';

const SidebarDeckItem = ({
  deck,
  dueCount,
  isSystem,
  isActive,
  isDragOver,
  isEditing,
  editingDeckName,
  onEditingNameChange,
  onRename,
  onCancelEdit,
  onClick,
  onDeckDragOver,
  onDragLeave,
  onDeckDrop,
  onOpenConfig,
  onStartEditing,
  onDelete,
}) => {
  const { t } = useTranslation(['sidebar', 'reader']);
  const displayName = isSystem ? t('reader:comments.title') : deck.name;

  return (
    <div
      className="list-item-wrapper"
      data-testid="sidebar-deck-item"
      data-system-deck={isSystem ? 'true' : 'false'}
    >
      {isEditing ? (
        <div className="new-list-input">
          <input
            type="text"
            value={editingDeckName}
            onChange={(e) => onEditingNameChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') onRename();
              if (e.key === 'Escape') onCancelEdit();
            }}
            onBlur={onRename}
            autoFocus
          />
        </div>
      ) : (
        <Link
          to={`/deck/${deck.id}`}
          className={`menu-item ${isSystem ? 'special-folder' : ''} ${isActive ? 'active' : ''} ${isDragOver ? 'drag-over' : ''}`}
          onClick={onClick}
          onDragOver={onDeckDragOver}
          onDragLeave={onDragLeave}
          onDrop={onDeckDrop}
          aria-current={isActive ? 'page' : undefined}
        >
          <span className="menu-item-label">
            {isSystem && <MessageSquare size={ICON_SIZE.sm} />}
            <span>{displayName}</span>
          </span>
          {(dueCount > 0 || isSystem) && (
            <span className="menu-count">
              {dueCount > 0 ? dueCount : '0'}
            </span>
          )}
        </Link>
      )}
      {/* Hide menu for system decks - they cannot be edited/renamed/deleted */}
      {!isSystem && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button
              className="list-menu-btn"
              aria-label={`${displayName}: ${t('sidebar:showMore')}`}
            >
              <MoreHorizontal size={ICON_SIZE.xs} />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="sidebar-row-menu" side="bottom" align="start" sideOffset={4}>
            <DropdownMenuItem onSelect={onOpenConfig}>
              <span>{t('sidebar:menu.settings')}</span>
            </DropdownMenuItem>
            <DropdownMenuItem onSelect={onStartEditing}>
              <span>{t('sidebar:menu.rename')}</span>
            </DropdownMenuItem>
            {!deck.is_default && (
              <DropdownMenuItem onSelect={onDelete}>
                <span>{t('sidebar:menu.delete')}</span>
              </DropdownMenuItem>
            )}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  );
};

export default SidebarDeckItem;
